import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import prefix from '../../utils/prefix';
import ProgressSpinner from '../ProgressSpinner';
import './styles.sass';
var modifiers = prefix('content-loader--');
var ContentLoading = function ContentLoading(_ref) {
  var small = _ref.small,
    smaller = _ref.smaller;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('content-loader', modifiers({
      small: small,
      smaller: smaller
    }))
  }, /*#__PURE__*/React.createElement(ProgressSpinner, {
    thickness: 3,
    size: 36,
    blue: true
  }));
};
ContentLoading.propTypes = {
  small: PropTypes.bool,
  smaller: PropTypes.bool
};
export default ContentLoading;
//# sourceMappingURL=index.js.map
